"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAddonsCssTransitionGroup = _interopRequireDefault(require("react-addons-css-transition-group"));

var _notification = _interopRequireDefault(require("./notification"));

require("./notification-list.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var NotificationList = function NotificationList(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "NotificationList ".concat(props.className)
  }, /*#__PURE__*/_react["default"].createElement(_reactAddonsCssTransitionGroup["default"], {
    transitionName: "notification",
    transitionEnterTimeout: 300,
    transitionLeaveTimeout: 300
  }, props.notifications.map(function (notification) {
    return /*#__PURE__*/_react["default"].createElement(_notification["default"], _extends({
      key: notification.id
    }, notification));
  })));
};

NotificationList.propTypes = {
  notifications: _propTypes["default"].arrayOf(_propTypes["default"].shape(_notification["default"].propTypes)).isRequired,
  className: _propTypes["default"].string
};
NotificationList.defaultProps = {
  className: 'inline'
};
var _default = NotificationList;
exports["default"] = _default;